module.exports = __webpack_public_path__ + "static/Stingray-6e545702cda309b06728bfd287e57747.png";